import React from 'react';
import { Shield, Lightbulb, Award, Leaf, Users } from 'lucide-react';
import { coreValues } from '../mockData';

const iconMap = {
  Shield,
  Lightbulb,
  Award,
  Leaf,
  Users
};

const About = () => {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
            About <span className="text-brand-red">Alakhe Conglomerate</span>
          </h2>
          <p className="text-xl text-gray-600">
            A dynamic and forward-thinking company delivering excellence across construction, 
            infrastructure, and industrial solutions in South Africa.
          </p>
        </div>

        {/* Split Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
                alt="Alakhe Conglomerate"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="text-brand-red text-4xl font-bold mb-1">Since 2018</div>
              <div className="text-gray-600 text-sm">
                Building Tomorrow's Infrastructure Today
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-charcoal mb-4">
              Leading the Way in Infrastructure Development
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Alakhe Conglomerate (Pty) Ltd is a South African company established in 2018, 
              operating from Reitz, Free State. We specialize in construction, property development, 
              and mining sectors, offering comprehensive professional services.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Our vision is to become a recognized leader known for excellence, innovation, 
              and dedication to sustainable development. We deliver high-quality services that 
              contribute to the sustainable development of communities and drive economic growth.
            </p>
            <div className="pt-4">
              <div className="flex items-center space-x-3 text-brand-red font-semibold">
                <div className="w-12 h-1 bg-brand-red"></div>
                <span>Reg: 2018/060750/07</span>
              </div>
            </div>
          </div>
        </div>

        {/* Core Values */}
        <div>
          <h3 className="text-3xl font-bold text-charcoal text-center mb-12">
            Our Core Values
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {coreValues.map((value) => {
              const Icon = iconMap[value.icon];
              return (
                <div
                  key={value.id}
                  className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-brand-red hover:shadow-lg transition-all duration-300 text-center group"
                >
                  <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-brand-red transition-colors">
                    <Icon className="w-8 h-8 text-brand-red group-hover:text-white transition-colors" />
                  </div>
                  <h4 className="text-lg font-bold text-charcoal mb-2">
                    {value.title}
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
